import * as React from 'react';
import { ZipCityViewModel, ZipCountyOptionsViewModel } from '@models/Vendor';
import { Card, CardHeader, CardBody } from '@common/components';
import { SelectCount } from './select-count.component';
import { City } from './trade-city.component';

interface CountyProperties {
  readonly county: ZipCountyOptionsViewModel;
  readonly selectedCount: number;
  readonly allSelected: boolean;
  readonly countyFilter: string;
  readonly selectedZips: string[];
  readonly toggleZips: Function;
  readonly cityZipFilter: string;
  readonly readonly?: boolean;
  readonly isTab?: boolean;
}

/**
 * Component for rendering zips at the county level
 *
 * @export
 * @class County
 * @extends {React.Component<CountyProperties>}
 */
export class County extends React.Component<CountyProperties> {
  /**
   * Only rerender if data or selection changes
   *
   * @param {CountyProperties} nextProps
   * @returns
   * @memberof County
   */
  shouldComponentUpdate(nextProps: CountyProperties) {
    return (
      this.props.selectedCount !== nextProps.selectedCount ||
      this.props.county.countyName !== nextProps.county.countyName
    );
  }
  render() {
    const { county, selectedCount, allSelected, countyFilter, selectedZips, toggleZips, cityZipFilter } = this.props;
    const total = county.cities.reduce(
      (sum: number, currentValue: ZipCityViewModel) => sum + currentValue.zipCodes.length,
      0
    );
    let zipsList: string[] = [];
    county.cities.map((city: ZipCityViewModel) => {
      zipsList = zipsList.concat(city.zipCodes);
    });
    return (
      // Filter results based on countyFilter string
      county.countyName.toLowerCase().indexOf(countyFilter.toLowerCase()) > -1 && (
        <Card zip={true} defaultClosed={true} active={selectedCount > 0}>
          <CardHeader isTab={this.props.isTab}>
            <div className="relative">
              <h2 className="inline-block">{county.countyName} County</h2>

              <SelectCount
                selectedCount={selectedCount}
                total={total}
                onChange={() => toggleZips(zipsList, allSelected)}
                readonly={this.props.readonly}
              />
            </div>
          </CardHeader>
          <CardBody>
            {county.cities.map((city: ZipCityViewModel) => {
              return (
                <City
                  readonly={this.props.readonly}
                  key={city.cityName}
                  city={city}
                  cityZipFilter={cityZipFilter}
                  selectedZips={selectedZips.filter(value => city.zipCodes.includes(value))}
                  toggleZips={toggleZips}
                  isTab={this.props.isTab}
                />
              );
            })}
          </CardBody>
        </Card>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/trade-zips/_components/trade-county-component.tsx